<ng-template #loading>
  <boma-anim-spinning-loader [size]="40"></boma-anim-spinning-loader>
</ng-template>
<div class="formgrid grid">
  <div class="field col mb-0">
    <label *ngIf="this.showLabels" class="mb-0"> Products </label>
    <span class="p-fluid">
      <p-dropdown
        *ngIf="!multipleProducts"
        [options]="productSearchResults?.items"
        [(ngModel)]="selectedProduct"
        [filter]="enableFilter"
        filterBy="name" 
        optionLabel="name"
        placeholder="Select a product"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38"
        (onChange)="handleSelectedProducts($event)"
      >
        <ng-template let-item pTemplate="item">
          <div class="dropdown-item">
            <p class="m-0 p-0">
              <span>
                <img
                  [alt]="item.name"
                  style="max-width: 30px; border-radius: 1em"
                  class="mr-2"
                  [src]="
                    item.images | getFirstAvailableImageForSize: '60'
                  " /></span
              >{{ item.name }}
            </p>
          </div>
        </ng-template>
      </p-dropdown>

      <p-multiSelect
        *ngIf="multipleProducts"
        appendTo="body"
        id="products"
        [options]="productSearchResults?.items"
        optionLabel="name"
        [(ngModel)]="selectedProducts"
        (onChange)="handleSelectedProducts($event)"
        (onClick)="searchProduct('')"
        [placeholder]="placeHolderText"
        [required]="requireSelection"
        [showClear]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="43"
        filter="name"
        name="productsSelector"
        filterMatchMode="contains"
        selectedItemsLabel="{0} products selected"
        [emptyMessage]="
          searching && !searched
            ? 'Searching Products...'
            : searched && !searching && productSearchResults?.items.length === 0
            ? 'No Products Found'
            : ''
        "
      >
        <ng-template let-item pTemplate="item">
          <div class="dropdown-item">
            <p class="m-0 p-0">
              <span>
                <img
                  [alt]="item.name"
                  style="max-width: 30px; border-radius: 1em"
                  class="mr-2"
                  [src]="
                    item.images | getFirstAvailableImageForSize: '60'
                  " /></span
              >{{ item.name }}
            </p>
          </div>
        </ng-template>
      </p-multiSelect>
    </span>
  </div>
</div>
